import { PhoneUtils } from "../PhoneUtils";

export const ResourceAccountThumb = ({ value }) => {
    return (
        <div>
            <div>{value.name}</div>
            <div className="text-muted">{PhoneUtils.format(value.phoneNumber)}</div>
        </div>
    );
}